import React from "react";
import { Box, Grid2, Slider } from "@mui/material";
import { SLIDER_PRECISION } from "../../hooks/video/useVideoPlayerState";

interface UCSliderProps {
  value: number;
  onChange: (event: unknown, value: number) => void;
  onChangeCommitted: (event: unknown, value: number) => void;
  disabled?: boolean;
}

const UCSlider: React.FC<UCSliderProps> = ({
  value,
  onChange,
  onChangeCommitted,
  disabled,
}) => {
  // This handler fires continuously during a drag
  const handleOnChange = (event: unknown, rawValue: number | number[]) => {
    const raw = Array.isArray(rawValue) ? rawValue[0] : rawValue;
    // We send the *inverted* value up to the parent hook
    onChange(event, SLIDER_PRECISION - raw);
  };
  
  // This handler fires once when the user releases the mouse
  const handleOnChangeCommitted = (event: unknown, rawValue: number | number[]) => {
    const raw = Array.isArray(rawValue) ? rawValue[0] : rawValue;
    // We send the *inverted* value up to the parent hook
    onChangeCommitted(event, SLIDER_PRECISION - raw);
  };


  return (
    <Grid2
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
      }}
    >
      <Box
        sx={{
          position: "relative",
          aspectRatio: "3 / 7",
          height: "auto",
          maxHeight: "65vh",
          maxWidth: "100%",
          width: "100%",
          borderRadius: "10px",
          overflow: "hidden"
        }}
      >

        {/* Vehicle overlay */}
        <Box
          className="uc-selector"
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundSize: "contain",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            zIndex: 1,
          }}
        />

        {/* Slider */}
        <Slider
          orientation="vertical"
          value={SLIDER_PRECISION - value}
          onChange={handleOnChange}
          onChangeCommitted={handleOnChangeCommitted}
          min={0}
          max={SLIDER_PRECISION}
          step={1}
          disabled={disabled}
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            height: "100%",
            width: "100%",
            zIndex: 2,
            color: "transparent",
            "& .MuiSlider-thumb": {
              height: "1px",
              width: "100%",
              backgroundColor: "#fff",
              border: "2px solid red",
            },
            "& .MuiSlider-rail, & .MuiSlider-track": {
              opacity: 0,
            },
          }}
        />
      </Box>
    </Grid2>
  );
};

export default UCSlider;
